import { useDeviceType } from "components/hooks/useDeviceType";
import { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";

function NavbarItem({ name, title, Icon, setItemRef }) {
  const device = useDeviceType();
  const location = useLocation();
  const ref = useRef(null);

  const isActive =
    location.pathname === `/${name}` ||
    (name === "main" && location.pathname === "/") ||
    location.pathname.startsWith(`/${name}/`);

  useEffect(() => {
    if (isActive && typeof setItemRef === "function") {
      setItemRef(ref);
    }
  }, [isActive, setItemRef]);

  return (
    <li className={`nav-item ${isActive ? "active" : ""}`} ref={ref}>
      <NavLink className="nav-link" to={`/${name}`}>
        {device === "desktop" ? title : <Icon className="admin-navbar-icon" />}
      </NavLink>
    </li>
  );
}

export default NavbarItem;